<template>
  <div v-if="count > 0">
    <v-btn v-if="hasPrevious" text dense @click="() => updateIndex(page - 1)"
      ><v-icon dark>arrow_back</v-icon></v-btn
    >
    <span>{{ paginationText }}</span>
    <v-btn v-if="hasNext" text dense @click="() => updateIndex(page + 1)"
      ><v-icon dark>arrow_forward</v-icon></v-btn
    >
  </div>
</template>

<script>
export default {
  name: 'BlogPaginationFilter',
  props: {
    count: {
      default: 0,
      type: Number,
    },
    page: {
      default: 1,
      type: Number,
    },
    size: {
      default: 10,
      type: Number,
    },
  },
  computed: {
    pageSize() {
      return this.size
    },
    hasPrevious() {
      return this.page > 1
    },
    hasNext() {
      return this.page * this.pageSize < this.count
    },
    paginationText() {
      return `Page ${this.page} of ${this.totalPages}`
    },
    totalPages() {
      return Math.ceil(this.count / this.pageSize)
    },
  },
  methods: {
    updateIndex(newIndex) {
      const query = { ...this.$route.query, page: newIndex }
      this.$router.push({ name: 'blog', query })
    },
  },
}
</script>
